import { memo, useCallback, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useCurrentNoteContextData } from 'lib/context/ClinicalNoteContext/CurrentNoteContext/CurrentNoteContext';
import { ia, io } from 'lib/helpers/utility';

import ChatRow from '../../MyScribeAI/Templates/shared/components/ChatRow';
import VirtualizedList from '../../MyScribeAI/Templates/shared/components/VirtualizedList';
import { transformData } from '../../MyScribeAI/Templates/shared/lib/helpers';

const MultipleTemplateView = ({ note, allForms = false }) => {
  const { type: noteType, formName } = useParams();

  const type = useRef();

  const { enabledNotes, virtuosoRef } = useCurrentNoteContextData();

  const forms = useMemo(() => {
    let filledForms = {};

    if (io(enabledNotes)) {
      if (!note) filledForms = enabledNotes;
      else if (enabledNotes[note]) filledForms = { [note]: enabledNotes[note] };

      return transformData(Object.values(filledForms));
    }

    return [];
  }, [note, JSON.stringify(enabledNotes)]);

  const renderRow = useCallback(
    (index, item, { isScrolling }) => {
      let head = null;

      if (allForms && (item?.type !== type.current || index === 0)) {
        type.current = item?.type;
        head = (
          <div className="py-1 pb-3 text-xl text-primary-500">{item?.typeLabel?.toUpperCase()}</div>
        );
      }

      return (
        <div className="mx-auto h-full w-full max-w-[968px] p-2">
          {head}
          <ChatRow
            key={`${item.key}-${item.type}`}
            item={item}
            components={{ [item.key]: item }}
            isScrolling={isScrolling}
          />
        </div>
      );
    },
    [allForms]
  );

  if (!ia(forms)) return null;

  let initialIndex = 0;

  if (noteType && formName) {
    const foundFormIndex = forms?.findIndex(
      (form) => form.type === noteType && form.path === formName
    );

    if (foundFormIndex > -1) initialIndex = foundFormIndex;
  }

  return (
    <div className="h-full">
      <VirtualizedList
        data={forms}
        renderItem={renderRow}
        virtuosoRef={virtuosoRef}
        initialIndex={initialIndex}
      />
    </div>
  );
};

export default memo(MultipleTemplateView);
